<template>
  <section class="privacy-page">
    <Header />
    <PrivacyPolicy />
    <Footer />
  </section>
</template>

<script>
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import PrivacyPolicy from "@/components/PrivacyPolicy";

export default {
  components: {
    Header,
    PrivacyPolicy,
    Footer,
  },
};
</script>
<style scoped>

* {
  color: #3d3d3d;
}

.privacy-page {
  width: 100%;
  box-sizing: border-box;
}

</style>
